"use client";
import { useEffect, useRef, useState } from "react";
// import {
//   Select,
//   SelectTrigger,
//   SelectValue,
//   SelectContent,
//   SelectItem,
// } from "@/components/ui/select";
import IntegrationList from "./IntegrationList";
import Link from "next/link";

interface Tab {
  id: number;
  tab: string;
  label: string;
}

const tabsData: Tab[] = [
  { id: 1, tab: "projectManagement", label: "Project Management" },
  { id: 2, tab: "taskManagement", label: "Task Management " },
  {
    id: 3,
    tab: "calendarAndCommunication",
    label: "Calendar & Communication",
  },
  { id: 4, tab: "productAndEngineering", label: "Product & Engineering" },
  { id: 5, tab: "docsAndFiles", label: "Docs & Files" },
  { id: 6, tab: "serviceManagement", label: "Service Management" },
  { id: 7, tab: "collaborationAndChat", label: "Collaboration & Chat" },
  { id: 8, tab: "crm", label: "CRM" },
];

export function useScrollSpy(ids: string[], options: IntersectionObserverInit) {
  const [activeId, setActiveId] = useState<string | null>(null);
  const observer = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    const elements = ids.map((id) => document.getElementById(id));
    observer.current?.disconnect();
    observer.current = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry?.isIntersecting) {
          setActiveId(entry.target.id);
        }
      });
    }, options);

    elements.forEach((el) => {
      if (el) observer.current?.observe(el);
    });

    return () => observer.current?.disconnect();
  }, [ids, options]);

  return activeId;
}
const smoothScrollToElement = (element: HTMLElement) => {
  const navbarHeight = 70;
  const targetPosition = element.offsetTop - navbarHeight - 20;
  const startPosition = window.scrollY;
  const distance = targetPosition - startPosition;
  const duration = 500;
  let startTime: number | null = null;

  const scrollStep = (timestamp: number) => {
    if (!startTime) startTime = timestamp;
    const progress = Math.min((timestamp - startTime) / duration, 1);
    window.scrollTo(0, startPosition + distance * progress);

    if (progress < 1) {
      requestAnimationFrame(scrollStep);
    }
  };

  requestAnimationFrame(scrollStep);
};
const IntegrationTabs = () => {
  const [activeTab, setActiveTab] = useState<string>("projectManagement");
  const [search, setSearch] = useState<string>("");

  const handleTabChange = (value: string) => {
    setActiveTab(value);
    setSearch("");

    window.history.pushState({}, "", `#${value}`);
    const element = document.getElementById(value);
    if (element) {
      smoothScrollToElement(element);
    }
  };

  const activeId = useScrollSpy(
    tabsData.map((tab) => tab.tab),
    { rootMargin: "-70px 0px -80% 0px" },
  );

  useEffect(() => {
    const tabFromUrl = window.location.hash.substring(1);
    if (tabFromUrl && tabsData.some((tab) => tab.tab === tabFromUrl)) {
      setActiveTab(tabFromUrl);
    }
  }, []);

  useEffect(() => {
    if (activeId && activeId !== activeTab) {
      setActiveTab(activeId);
    }
  }, [activeId, activeTab]);

  return (
    <main className="text-[#202020]">
      <div className="mx-auto max-w-screen-2xl py-8">
        <div className="mb-10 flex flex-row gap-2 lg:gap-8">
          <div className="sticky top-[4.4rem] z-20 w-[30%] flex-initial text-left xlg:w-[25%]">
            <div className="sticky top-28">
              <div className="rounded-[8px]">
                <div className="h-full space-y-2 rounded-[8px] bg-white text-sm font-medium text-gray-500 xlg:space-y-4">
                  <h3 className="mb-2 text-[18px] font-semibold text-[#202020] xlg:mb-4 xl:text-[22px]">
                    Categories
                  </h3>
                  <ul className="block">
                    {tabsData.map((tabItem) => (
                      <li key={tabItem.id} className="rounded-[8px]">
                        <Link
                          href={`#${tabItem.tab}`}
                          passHref
                          onClick={(e) => {
                            e.preventDefault();
                            handleTabChange(tabItem.tab);
                          }}
                        >
                          <p
                            className={`w-full rounded-[8px] px-2 py-1 text-left text-[12px] font-normal sm:text-[14px] lg:px-2.5 lg:py-2.5 xl:text-[16px] ${activeTab === tabItem.tab
                              ? "border-[#202020] bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent"
                              : "border-[#E0E0EA] bg-white text-[#4A4A4A] hover:border-[#C5C5D8]"
                              }`}
                          >
                            {tabItem.label}
                          </p>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="w-[68%] flex-initial text-left xlg:w-[72%]">
            <IntegrationList
              activeTab={activeTab}
              searchTerm={search}
              setSearchTerm={setSearch}
            />
          </div>
        </div>
      </div>
    </main>
  );
};

export default IntegrationTabs;
